export const envs = { VITE_BASE_URL: '/lab-web', VITE_ENVIRONMENT: 'production' };
